import React from 'react';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { styles } from './SearchTooltip.css';

export type SearchTooltipProps = {
  title: string;
  body: string;
  className?: string;
  style?: React.CSSProperties;
  arrow?: 'down' | 'up';
  arrowOffset?: string;
  id?: string;
};

export const SearchTooltip = ({
  title,
  body,
  className,
  style,
  arrow = 'down',
  arrowOffset,
  id,
}: SearchTooltipProps) => {
  const arrowStyle = arrowOffset ? { left: arrowOffset } : undefined;

  return (
    <div className={classNames(styles.wrapper, className)} style={style} role="tooltip" id={id}>
      {arrow === 'up' && <div className={styles.arrowUp} style={arrowStyle} />}
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.title}>{title}</div>
          <div className={styles.body}>{body}</div>
        </div>
      </div>
      {arrow === 'down' && <div className={styles.arrowDown} style={arrowStyle} />}
    </div>
  );
};
